<div class="row">
    <div class="col-12">
        <h2>History comments</h2><br>

        <label for=""> <span>Comments OE:</span></label><br>
        <textarea
        class="textarea__area-modal--size-small textarea__area-modal--color-table"
        [disabled]= "true">{{ data.name.commentsActionEGF }}</textarea>
        <br><br>
      
<hr>
        <table mat-table [dataSource]="dataSource" class="mat-elevation-z8">
            <ng-container matColumnDef="Status">
                <th mat-header-cell *matHeaderCellDef><h3>Status.</h3></th>
                <td mat-cell *matCellDef="let element"> {{element.status}} </td>
            </ng-container>
            <ng-container matColumnDef="Comment">
                <th mat-header-cell *matHeaderCellDef> <h3>Comment.</h3>  </th>
                <td mat-cell *matCellDef="let element"> {{element.comment}} </td>
            </ng-container>
            <ng-container matColumnDef="Date">
                <th mat-header-cell *matHeaderCellDef> <h3>Date.</h3> </th>
                <td mat-cell *matCellDef="let element"> {{element.date}} </td>
            </ng-container>

            <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
            <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
        </table>
    </div>
</div>

 